export type DateRange = {
  startDate: string;
  endDate: string;
};

export type Nullable<T> = T | null;

export const ISMS_URL =
  "https://isms.kisa.or.kr/main/ispims/issue/?certificationMode=list&crtfYear=&pageFlag=ISMS-P&searchCondition=2&searchKeyword=%EC%97%90%EC%8A%A4%EC%95%A4%EC%95%84%EC%9D%B4%EC%BD%94%ED%8D%BC%EB%A0%88%EC%9D%B4%EC%85%98";
